exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-star-rating-star[data-v-5d61ae9c]{overflow:visible!important}.vue-star-rating-star-rotate[data-v-5d61ae9c]{-webkit-transition:all .25s;transition:all .25s}.vue-star-rating-star-rotate[data-v-5d61ae9c]:hover{-webkit-transition:-webkit-transform .25s;transition:-webkit-transform .25s;transition:transform .25s;transition:transform .25s,-webkit-transform .25s;-webkit-transform:rotate(-15deg) scale(1.3);transform:rotate(-15deg) scale(1.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d61ae9c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-star-rating/src/star.vue
// module id = 664
// module chunks = 0